import Dashboard from "./pages/admin/Dashboard/Index";
import Profile from "./pages/admin/Profile/Index";
import PropertiesCollection from "./pages/admin/PropertiesCollection/Index";
import PropertiesCollectionCreate from "./pages/admin/PropertiesCollection/Create";
import PropertiesCollectionUpdate from "./pages/admin/PropertiesCollection/Update";
import Users from "./pages/admin/Users/Index";
import UsersCreate from "./pages/admin/Users/Create";
import UsersUpdate from "./pages/admin/Users/Update";
import PagesAdmin from "./pages/admin/Pages/Index";
import PagesCreate from "./pages/admin/Pages/Create";
import PagesUpdate from "./pages/admin/Pages/Update";
import ExperiencesAdmin from "./pages/admin/Experiences/Index";
import ExperiencesCreate from "./pages/admin/Experiences/Create";
import ExperiencesUpdate from "./pages/admin/Experiences/Update";
import CategoriesAdmin from "./pages/admin/Categories/Index";
import CategoriesCreate from "./pages/admin/Categories/Create";
import CategoriesUpdate from "./pages/admin/Categories/Update";

const AdminRoutes = [
  { index: false, element: <PagesAdmin />, isInSidebar: true, name: "Pages", path: "/admin/pages" },
  { index: false, element: <PagesCreate />, isInSidebar: false, name: "Page Create", path: "/admin/pages/create" },
  { index: false, element: <PagesUpdate />, isInSidebar: false, name: "Pages Update", path: "/admin/pages/update" },
  { index: true, element: <PropertiesCollection />, isInSidebar: true, name: "Property Collection", path: "/admin/properties-collection" },
  { index: false, element: <PropertiesCollectionCreate />, isInSidebar: false, name: "Property Collection", path: "/admin/properties-collection/create" },
  { index: false, element: <PropertiesCollectionUpdate />, isInSidebar: false, name: "Property Collection", path: "/admin/properties-collection/update" },
  { index: false, element: <ExperiencesAdmin />, isInSidebar: true, name: "Experiences", path: "/admin/experiences" },
  { index: false, element: <ExperiencesCreate />, isInSidebar: false, name: "Experiences Create", path: "/admin/experiences/create" },
  { index: false, element: <ExperiencesUpdate />, isInSidebar: false, name: "Experiences Update", path: "/admin/experiences/update" },
  { index: false, element: <CategoriesAdmin />, isInSidebar: true, name: "Categories", path: "/admin/categories" },
  { index: false, element: <CategoriesCreate />, isInSidebar: false, name: "Categories Create", path: "/admin/categories/create" },
  { index: false, element: <CategoriesUpdate />, isInSidebar: false, name: "Categories Update", path: "/admin/categories/update" },
  { index: false, element: <Users />, isInSidebar: true, name: "Users", path: "/admin/users" },
  { index: false, element: <UsersCreate />, isInSidebar: false, name: "User Create", path: "/admin/users/create" },
  { index: false, element: <UsersUpdate />, isInSidebar: false, name: "User Update", path: "/admin/users/update" },
  { index: false, element: <Profile />, isInSidebar: false, name: "Profile", path: "/admin/profile" },
  { index: false, element: <PagesAdmin />, isInSidebar: false, name: "Pages", path: "/admin/*" }

];

export {
  AdminRoutes
} 
